import { useEffect, useState } from "react";
import api from "../Services/api";


const ViverMelhorExtraPageLayout = (props: any) => {

  const [page, setLayoutPagina] = useState<any[]>([]);

  useEffect(() => {
    api
      .get("/ObterLayoutPaginaFiltro?Identificador=" + props.page)

      .then((response) => {

        //somente para o mock
        var result = response.data.results.filter(function (r: any) { return r?.Identificador.toUpperCase() === props.page.toUpperCase(); });

        setLayoutPagina(result);
      })
      .catch((err) => {
        throw new Error(err);
      });
  }, [props.page]);

  function renderObjectBody(data: any) {
    return { __html: data }
  }

  return (
    <>
      <div className='row justify-content-center'>
        <div className="col-lg-10 col-xl-10 section-page">

          {page?.map(item => (
            <span key={item.ID}>
              {item.Corpo &&
                <span  dangerouslySetInnerHTML={renderObjectBody(item.Corpo)} />
              }
            </span>

          ))}

        </div>
      </div>
    </>
  )
}

export default ViverMelhorExtraPageLayout;